export const TrustManager = {
  "Modal": {
    "Title": "Trust Manager",
    "Cancel": "Cancel",
    "Ok": "OK"
  },
  "Content": {
    "EnableJavaScript": {
      "Title": "JavaScript",
      "Checkbox": "Enable JavaScript Actions"
    },
    "TrustManager": {
      "Title": "Safe Reading Mode prevents unauthorized actions and data transmission, including Internet connections and opening attachments, to avoid attacks form malicious documents.",
      "Checkbox": "Enable Safe Reading Mode"
    }
  }
}